
import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight, Building2 } from 'lucide-react';
import { getTownBySlug } from '@/data/townData';

interface ServiceLocationLinksProps {
  targetTowns: string[];
  serviceName: string;
  commercialAvailable: boolean;
}

const ServiceLocationLinks = ({ targetTowns, serviceName, commercialAvailable }: ServiceLocationLinksProps) => {
  const towns = targetTowns.map(slug => getTownBySlug(slug)).filter(Boolean);

  if (towns.length === 0) return null;

  return (
    <section className="py-12 bg-pkstone-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl font-serif font-bold text-pkstone-900 mb-6">
            {serviceName} Service Areas
          </h2>
          
          <p className="text-pkstone-600 mb-8">
            We provide {serviceName.toLowerCase()} services throughout Fairfield County and New Haven County, Connecticut. 
            Click on a town below to learn more about our services in your area.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
            {towns.map((town) => town && (
              <Link
                key={town.slug}
                to={`/locations/${town.slug}`}
                className="bg-white p-4 rounded-lg hover:shadow-md transition-all group flex items-center gap-3"
              >
                <MapPin className="h-5 w-5 text-pkgreen-600 flex-shrink-0" />
                <span className="text-pkstone-800 font-medium text-sm group-hover:text-pkgreen-700">
                  {town.name}, CT
                </span>
              </Link>
            ))}
          </div>

          <div className="flex flex-wrap gap-4">
            <Link
              to="/locations"
              className="text-pkgreen-600 hover:text-pkgreen-700 font-medium inline-flex items-center"
            >
              View All Service Areas
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
            
            {commercialAvailable && (
              <Link
                to="/commercial"
                className="text-pkgreen-600 hover:text-pkgreen-700 font-medium inline-flex items-center"
              >
                <Building2 className="mr-2 h-4 w-4" />
                Commercial Services
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceLocationLinks;
